import React from 'react';
import { Location } from 'history';

import PriceGuideToolFormContainer from './price_guide_tool_form_container';
import PriceGuideToolPageWrapper from '../price_guide_tool_page_wrapper';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

export const COMPONENT_NAME = 'PriceGuideToolShow';

interface ExternalProps {
  routeParams: {
    cspSlug: string;
  };
  location?: Location;
}

export default function PriceGuideToolShow({ routeParams, location }: ExternalProps) {
  const { cspSlug } = routeParams;

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: COMPONENT_NAME,
    entityId: cspSlug,
    cspSlug,
  }, true);

  return (
    <PriceGuideToolPageWrapper parentComponentName="PriceGuideToolShow">
      <PriceGuideToolFormContainer
        cspSlug={cspSlug}
        location={location}
      />
    </PriceGuideToolPageWrapper>
  );
}
